import { observer } from 'mobx-react-lite';
import { useRef, useMemo } from 'react';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Mousewheel, FreeMode } from 'swiper/modules';
import { Swiper as SwiperClass } from 'swiper/types';
import FilterMultiselectState from '@features/categories/mobx/state/FilterMultiselectState';
import styles from '@features/categories/components/CategoriesFilterMultiselect/CategoriesFilterMultiselect.styles';
import useFilterOptionValue from '@hooks/useFilterOptionValue';
import Icon from '@components/icons/Icon';
import Checkbox from '@components/Checkbox/Checkbox';
import Check from '@components/icons/components/Check';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/scrollbar';
type PropsType = {
  filter: FilterMultiselectState;
  dropdown?: boolean;
};
const DROPDOWN_MAX_ITEMS_COUNT = 8;
const CategoriesFilterMultiselect = observer(({
  filter,
  dropdown = false
}: PropsType) => {
  const {
    options,
    key
  } = filter;
  const optionsIterator = useMemo(() => Object.keys(options), [options]);
  // TODO: fix proper recognizion of filter type
  const isWithImage = key === 'color';
  const getFilterOptionValue = useFilterOptionValue(options, key);
  const swiperInstance = useRef<SwiperClass>(null);
  const renderWithoutImage = () => optionsIterator.length > DROPDOWN_MAX_ITEMS_COUNT ? <div sx={styles.list(dropdown)}>
        <Swiper direction="vertical" modules={[Scrollbar, Mousewheel, FreeMode]} scrollbar={{
      draggable: true
    }} onSwiper={swiper => {
      swiperInstance.current = swiper;
    }} followFinger slidesPerView="auto" freeMode mousewheel>
          {optionsIterator && optionsIterator.map((optionId, index) => {
        const isActive = filter.value.includes(optionId);
        const handleClick = () => {
          const newValue = isActive ? filter.value.filter(val => val !== optionId) : [...filter.value, optionId];
          filter.setValue(newValue);
        };
        return <SwiperSlide key={optionId}>
                  <div sx={styles.checkboxContainer}>
                    <Checkbox value={isActive} onChange={handleClick} showError={false} addSx={styles.checkbox(dropdown, index)} cy="CategoriesFilterMultiselectItem">
                      {getFilterOptionValue(optionId)}
                    </Checkbox>
                  </div>
                </SwiperSlide>;
      })}
        </Swiper>
      </div> : <div sx={styles.list(false)}>
        {optionsIterator && optionsIterator.map((optionId, index) => {
      const isActive = filter.value.includes(optionId);
      const handleClick = () => {
        const newValue = isActive ? filter.value.filter(val => val !== optionId) : [...filter.value, optionId];
        filter.setValue(newValue);
      };
      return <div sx={styles.checkboxContainer} key={optionId}>
                <Checkbox value={isActive} onChange={handleClick} showError={false} addSx={styles.checkbox(dropdown, index)} cy="CategoriesFilterMultiselectItem">
                  {getFilterOptionValue(optionId)}
                </Checkbox>
              </div>;
    })}
      </div>;
  const renderWithImage = () => <ul sx={styles.filterList}>
      {optionsIterator && optionsIterator.map(optionId => {
      const {
        featureImageUrl: imageUrl
      } = options[optionId];
      const isActive = filter.value.includes(optionId);
      const handleClick = () => {
        const newValue = isActive ? filter.value.filter(val => val !== optionId) : [...filter.value, optionId];
        filter.setValue(newValue);
      };
      return optionId && <li key={optionId} sx={styles.filterElement(dropdown)} data-cy="CategoriesFilterMultiselectItem">
                <button type="button" sx={styles.buttonWrapper} onClick={handleClick}>
                  <span sx={styles.imgWrapper(isActive, dropdown)}>
                    {isActive && <span sx={styles.checkIcon}>
                        <Icon size={dropdown ? '16px' : '24px'}>
                          <Check />
                        </Icon>
                      </span>}
                    {imageUrl ? <ResponsiveImage image={imageUrl} width={42} height={42} alt={getFilterOptionValue(optionId)} sx={styles.imageFill} /> : <span sx={styles.imgPlaceholder} />}
                  </span>
                  <span>{getFilterOptionValue(optionId)}</span>
                </button>
              </li>;
    })}
    </ul>;
  return <div data-cy="CategoriesFilterMultiselect">{isWithImage ? renderWithImage() : renderWithoutImage()}</div>;
});
export default CategoriesFilterMultiselect;